export const ACTION_LOGIN = "LOGIN";
export const ACTION_SIGNUP = "SIGNUP";
export const CORRECT_PASSWORD = "correctPassword";
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_NOTIFICATIONS_PAGE_SIZE = 10;
export const ID_EV_ALERTS = "Alertas EV";
export const MSG_ERROR_RECAPTCHA =
  "La verificación reCAPTCHA no fue superada correctamente. Por favor, intenta completar el proceso nuevamente.";


export const STATE_NON_COMPLIANCE_REPORT =  "Cerrada – Reporte de incumplimiento";

// Estados para consumidor financiero en el contexto de quejas agiliza
export const STATE_CF_CLOSED_PROPOSAL_ACCEPTED =
  "Cerrada – contrapropuesta aceptada";
export const STATE_CF_CLOSED_WITHDRAWAL = "Cerrada – desistimiento";
export const STATE_CF_PENDING_ACTION = "Gestión pendiente";
export const STATE_CF_PENDING_ENTITY_RESPONSE =
  "Respuesta de entidad pendiente";
export const STATE_CF_PROPOSAL_SUPERVISED_ENTITY =
  "Contrapropuesta entidad vigilada";
export const STATE_CF_SCHEDULED_CHAT_SESSION = "Sesión de chat";
export const STATE_CF_PENDING_SCHEDULE_SESSION = "Sesión de chat pendiente de agendar por facilitador SFC";

// Estados para entidad vigilada en el contexto de quejas agiliza
export const STATE_EV_PENDING_ACTION = "Gestión pendiente";
export const STATE_EV_PENDING_FACILITATOR_SCHEDULE = "Pendiente atender solicitud de reprogramación";
export const STATE_EV_SCHEDULED_CHAT_SESSION = "Sesión de chat";


// Acciones para servicio web de actualización de informacion de quejas agiliza
export const ACEPTAR_CONTRAPROPUESTA_CF = "aceptar_contrapropuesta_cf";
export const DESISTIMIENTO_CF = "desistimiento_cf";
export const RECHAZAR_CONTRAPROPUESTA_CF = "rechazar_contrapropuesta_cf";
export const REPORTAR_INCUMPLIMIENTO_CF = "reportar_incumplimiento_cf";
export const REPORTAR_INCUMPLIMIENTO_FACILITACION = "reporta_incumplimiento_facilitacion_cf";
export const RESPUESTA_INCUMPLIMIENTO_FACILITACION = "respuesta_incumplimiento_facilitacion";

export const PRESENTA_CONTRAPROPUESTA_EV = "presenta_contrapropuesta_ev";

// Estados para construccion de graficas

export const STATE_SFC_PENDIENTE_GESTION =
  "Pendiente gestión/respuesta Entidad Vigilada";
export const STATE_SFC_CONTRAPROPUESTA_EV = "Contrapropuesta entidad vigilada";
export const STATE_SFC_SESION_CHAT_PROGRAMADA = "Sesión de chat";
export const STATE_SFC_CERRADA_CONTRAPROPUESTA_ACEPTADA =
  "Cerrada – contrapropuesta aceptada";
export const STATE_SFC_CERRADA_DESISTIMIENTO = "Cerrada – desistimiento";
export const STATE_SFC_CERRADA_INACTIVIDAD_CF =
  "Cerrada – inactividad del consumidor";

// Estados para las sesiones Agiliza
export const ID_STATE_SESION_CERRADA_MEDIACION_ACUERDO = 7;
export const ID_STATE_SESION_CERRADA_MEDIACION_SIN_ACUERDO = 8;
export const ID_STATE_SESION_CERRADA_INASISTENCIA_CHAT_EV  = 10;
export const ID_STATE_SESION_CERRADA_INASISTENCIA_CHAT_CF = 11;

export const STATE_SESION_PENDIENTE_AGENDAR = "Pendiente por agendar";
export const STATE_SESION_CHAT_AGENDADA = "Sesión de chat agendada";
export const STATE_SESION_CERRADA_MEDIACION_ACUERDO = "Cerrada – mediación con acuerdo";
export const STATE_SESION_CERRADA_MEDIACION_SIN_ACUERDO = "Cerrada – mediación sin acuerdo";
export const STATE_SESION_CERRADA_INASISTENCIA_CHAT_EV  = "Cerrada – inasistencia al chat por parte de EV";
export const STATE_SESION_CERRADA_INASISTENCIA_CHAT_CF = "Cerrada – inasistencia al chat por parte de CF";
export const STATE_SESION_PENDIENTE_ATENDER_REPROGRAMACION =
  "Pendiente atender solicitud de reprogramación";
export const STATE_SESION_FINALIZADA = "Sesión finalizada";
export const STATE_SESION_FINALIZADA_SIN_GESTION = "Sesion finalizada y sin gestión";

// Estados para las sesiones Agiliza - Consumidor financiero (CF)
export const STATE_SESION_CF_PENDIENTE_AGENDAR = "Pendiente por agendar por parte de facilitador SFC"; 

// Estados para las sesiones Agiliza - Consumidor financiero (CF)
export const STATE_SESION_EV_REPROGRAMACION_PENDIENTE_FACILITADOR = "Solicitud de reprogramación pendiente de gestión por facilitador SFC";

// Paleta de colores SFC
export const SFC_COLOR_AMARILLO = "#ffdd00";
export const SFC_COLOR_AZUL = "#1778bd";
export const SFC_COLOR_AZUL_CELESTE = "#05b5cc";
export const SFC_COLOR_MORADO = "#7030a0";
export const SFC_COLOR_NARANJA = "#e86e1c";
export const SFC_COLOR_NEGRO = "#333333";
export const SFC_COLOR_ROJO = "#ee2121";
export const SFC_COLOR_VERDE = "#239b00";
export const SFC_COLOR_VERDE_CLARO = "#e4f4ed";
